<template>
    <div>
        <div class="container lnb d_container">
            <div class="contents_wrap">
                <div class="contents list-container">
                    <div class="title">{{ $route.meta.title }}</div>
                    <live-klass-write-component :liveklassType="`liveKlassCreate`"></live-klass-write-component>
                    <div class="pa15 text-center btn_wrap">
                        <el-button type="save" @click="save">저장</el-button>
                        <el-button type="cancel" @click="$router.push('/content/liveklass')">목록</el-button>
                    </div>
                </div>
            </div>

            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import LiveKlassWriteComponent from "@/components/liveklass/LiveKlassWriteComponent";

export default {
    name: "LiveKlassCreate",
    mixins: [],
    components: {LiveKlassWriteComponent},
    provide() {
        return {};
    },
    props: {},
    data() {
        return {
        };
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        save() {
            EventBus.$emit("writeLiveKlass");
        },
    },
    watch: {

    },
};
</script>

<style scoped></style>
